// extracted by mini-css-extract-plugin
module.exports = {"customImage":"CustomImage_customImage__3JXLx"};